import { Injectable } from '@angular/core'
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'

@Injectable({
  providedIn: 'root'
})
export class YoutubeService {

  constructor() { }

  public extractVideoId = (url: string): string => {
    if (!url) return ''
    const watchMatch = url.match(/[?&]v=([^&#]+)/)
    if (watchMatch) return watchMatch[1]
    const embedMatch = url.match(/embed\/([^?&#]+)/)
    if (embedMatch) return embedMatch[1]
    const shortMatch = url.match(/youtu\.be\/([^?&#]+)/)
    if (shortMatch) return shortMatch[1]
    if (/^[a-zA-Z0-9_-]{11}$/.test(url)) return url
    return ''
  }

  public getThumbnailUrl = (videoId: string): string => {
    return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : ''
  }

  public openVideo = async (videoId: string): Promise<void> => {
    if (!videoId) return
    await Browser.open({ url: `https://www.youtube.com/watch?v=${videoId}` })
  }

  public isIOS = (): boolean => {
    return Capacitor.getPlatform() === 'ios'
  }
}
